import MapDevice from './index.vue'

export default MapDevice
